<sc-flex vertical fitHeight stretchContent
  class="no-field-space article-type-attribute-editor">
  <sc-dialog-title>
    <sc-dictionary-label dictionaryKey="erp.ui.article-editor.title"></sc-dictionary-label>
  </sc-dialog-title>

  <app-service-response [responseMessages]="responseMessages"></app-service-response>
  <sc-flex-fitting-content vertical>
    <sc-scroll-pane>
      <form [formGroup]="formGroup">
        <sc-padding>
          <sc-flex stretchContent>
            <sc-flex-fitting-content>
              <sc-flex vertical stretchContent>
                <mat-form-field appearance="fill" read>
                  <mat-label>
                    <sc-dictionary-label dictionaryKey="erp.entity.article.id"></sc-dictionary-label>
                  </mat-label>
                  <input matInput formControlName="id" [readonly]="true">
                </mat-form-field>
                <sc-content-spacer vertical></sc-content-spacer>
                <sc-dictionary-field [model]="articleType?.name" [maxlength]="255"
                  defaultLabel="Article Type" [disabled]="true"
                  labelDictionaryKey="erp.entity.article.name">
                </sc-dictionary-field>
                <sc-content-spacer vertical></sc-content-spacer>
                <mat-checkbox name="archived" formControlName="archived">
                  <sc-dictionary-label dictionaryKey="erp.entity.article.archived"></sc-dictionary-label>
                </mat-checkbox>
              </sc-flex>
            </sc-flex-fitting-content>
          </sc-flex>
          <sc-content-spacer vertical [double]="true"></sc-content-spacer>
          <sc-sub-title>
            <sc-dictionary-label dictionaryKey="erp.ui.article-editor.subtitle.attribute-list"></sc-dictionary-label>
          </sc-sub-title>
          <sc-content-spacer vertical></sc-content-spacer>
          <sc-flex stretchContent>
            @for (group of attributeGroupsArtice; track group; let i = $index) {
              <ng-container [formGroup]="attributesFormGroup">
                @if (i>0) {
                  <sc-content-spacer></sc-content-spacer>
                }
                <sc-flex-fitting-content>
                  <sc-bordered-tile>
                    <sc-padding>
                      @if (article != null) {
                        <app-dictionary-entry-label [model]="group.name"></app-dictionary-entry-label>
                        <app-attribute-group [formGroup]="attributesFormGroup" [attributeGroup]="group" [valuesMap]="article.valuesMap" [usage]="group.usage"></app-attribute-group>
                      }
                    </sc-padding>
                  </sc-bordered-tile>
                </sc-flex-fitting-content>
              </ng-container>
            }
          </sc-flex>
          <sc-content-spacer vertical [double]="true"></sc-content-spacer>
          <sc-sub-title>
            <sc-dictionary-label dictionaryKey="erp.ui.article-editor.subtitle.descriptions"></sc-dictionary-label>
            <sc-content-spacer grow></sc-content-spacer>
            <button mat-stroked-button (click)="addDescription()">
              <mat-icon><sc-icon iconClass="fa-plus"></sc-icon></mat-icon>
              add
            </button>
          </sc-sub-title>
          <sc-content-spacer vertical></sc-content-spacer>

          <sc-bordered-tile>
            <sc-scroll-pane>
              <table mat-table [dataSource]="descriptionsDataSource" matSort
                (matSortChange)="announceSortChange($event)">

                <ng-container matColumnDef="usage">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header
                    sortActionDescription="Sort by usage">
                    <sc-dictionary-label dictionaryKey="erp.ui.article-editor.table.description.usage"></sc-dictionary-label>
                  </th>
                  <td mat-cell *matCellDef="let element"> {{element.usage}} </td>
                </ng-container>

                <ng-container matColumnDef="content">
                  <th mat-header-cell *matHeaderCellDef>
                    <sc-dictionary-label dictionaryKey="erp.ui.article-editor.table.description.title-text"></sc-dictionary-label>
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <p><strong><app-dictionary-entry-label [model]="element.title"></app-dictionary-entry-label></strong></p>
                    <p style="word-wrap: break-word; white-space: pre-wrap;"><app-dictionary-entry-label [model]="element.text"></app-dictionary-entry-label></p>
                  </td>
                </ng-container>

                <ng-container matColumnDef="commands">
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell *matCellDef="let element">
                    <button mat-icon-button (click)="editDescription(element)"><sc-icon
                    class="fa-light fa-pencil"></sc-icon></button>
                    <button mat-icon-button (click)="removeDescription(element)"><sc-icon
                    class="fa-light fa-trash"></sc-icon></button>
                  </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="descriptionDisplayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: descriptionDisplayedColumns;"></tr>
              </table>
            </sc-scroll-pane>
          </sc-bordered-tile>

          <sc-content-spacer vertical [double]="true"></sc-content-spacer>
          <sc-sub-title>
            <sc-dictionary-label dictionaryKey="erp.ui.article-editor.subtitle.retailprices"></sc-dictionary-label>
            <sc-content-spacer grow></sc-content-spacer>
            <mat-checkbox name="retailPricesFromBasicArticle" formControlName="retailPricesFromBasicArticle">
              <sc-dictionary-label dictionaryKey="erp.ui.article-editor.action.use-retailprices-from-basicarticle"></sc-dictionary-label>
            </mat-checkbox>
            <sc-content-spacer></sc-content-spacer>
            <button mat-stroked-button (click)="addRetailPrice()" [disabled]="this.article.retailPricesFromBasicArticle === true">
              <mat-icon><sc-icon iconClass="fa-plus"></sc-icon></mat-icon>
              <sc-dictionary-label dictionaryKey="erp.ui.article-editor.action.add-retailprice"></sc-dictionary-label>
            </button>
          </sc-sub-title>
          <sc-content-spacer vertical></sc-content-spacer>

          <sc-bordered-tile>
            @if (article.retailPricesFromBasicArticle === false) {
              <app-retailprice-list [columns]="retailPricesDisplayedColumns"
                [datasource]="retailPricesDataSource"
                [editRetailPriceFunction]="editRetailPrice"
              [removeRetailPriceFunction]="removeRetailPrice"></app-retailprice-list>
            }
            @if (article.retailPricesFromBasicArticle === true) {
              <app-retailprice-basicarticle-list [columns]="retailPricesBasicArticleDisplayedColumns"
              [datasource]="retailPricesBasicArticleDataSource"></app-retailprice-basicarticle-list>
            }
          </sc-bordered-tile>

          <sc-content-spacer vertical [double]="true"></sc-content-spacer>
          <sc-sub-title>
            <sc-dictionary-label dictionaryKey="erp.ui.article-editor.subtitle.costsprices"></sc-dictionary-label>
            <sc-content-spacer grow></sc-content-spacer>
            <button mat-stroked-button (click)="addCostsPrice()">
              <mat-icon><sc-icon iconClass="fa-plus"></sc-icon></mat-icon>
              <sc-dictionary-label dictionaryKey="erp.ui.article-editor.action.add-costsprice"></sc-dictionary-label>
            </button>
          </sc-sub-title>
          <sc-content-spacer vertical></sc-content-spacer>

          <sc-bordered-tile>
            <app-costsprice-list
              [articleType]="articleType"
              [hideVatPrices]="hideVatPrices"
              [datasource]="costsPricesDataSource"
              [editCostsPriceFunction]="editCostsPrice"
            [removeCostsPriceFunction]="removeCostsPrice"></app-costsprice-list>
          </sc-bordered-tile>

        </sc-padding>
      </form>
    </sc-scroll-pane>
  </sc-flex-fitting-content>

  <sc-actionbar>
    <sc-content-spacer grow></sc-content-spacer>
    <button mat-stroked-button (click)="onClose()">
      <sc-dictionary-label dictionaryKey="erp.ui.article-editor.action.cancel"></sc-dictionary-label>
    </button>
    <sc-content-spacer></sc-content-spacer>
    <button mat-flat-button (click)="onConfirm()" [disabled]="confirmDisabled">
      <sc-dictionary-label dictionaryKey="erp.ui.article-editor.action.confirm"></sc-dictionary-label>
    </button>
  </sc-actionbar>
</sc-flex>
